import { observer } from 'mobx-react';
import * as React from 'react';
import { MovieDetails } from '../stores/movierental/MovieDetailsStore';
import { ContentType } from '../stores/movierental/MovieRentalCatalogStore';
import { TranslationsContext } from '@teliaee/telia-translate';

interface MovieLengthProps {
  type: string;
  movieDetails: MovieDetails;
}

function MovieLength(props: MovieLengthProps): JSX.Element {
  const translate = React.useContext(TranslationsContext).translate;
  const { type, movieDetails } = props;

  const duration = type === ContentType.ASSETS ? movieDetails.duration : movieDetails.averageEpisodeDuration;
  const durationLabel = type === ContentType.ASSETS ? 'movieRental.length' : 'movieRental.averageLength';

  if (!duration) {
    return null;
  }
  return (
    <>
      <p className="text-tiny">{translate(durationLabel)}</p>
      <p>
        <>{duration && Math.floor(duration / 3600)}</>
        <>{translate('movieRental.hour')} </>
        <>{duration && Math.floor((duration % 3600) / 60)}</>
        <>{translate('movieRental.minute')} </>
      </p>
    </>
  );
}

export default observer(MovieLength);
